import { ContractInfo } from "../../types";
import { useState } from "react";
import Api from "../../Api";
import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import _ from "lodash";
import { Link } from "react-router-dom";

const defaultInfo: ContractInfo = {
  info: "",
  type: "clicksign",
  sent: false,
  signed: false,
};

const ContractForm = ({
  uuid,
  type,
  contractInfo,
  onSave,
}: {
  uuid: string;
  type: "rent" | "monitoring";
  contractInfo: ContractInfo | null;
  onSave: () => void;
}) => {
  const initial = contractInfo ?? defaultInfo;

  const [info, setInfo] = useState<ContractInfo>(initial);

  const isDirty = !_.isEqual(initial, info);

  const set = (key: keyof ContractInfo) => (value: string | boolean) => {
    setInfo((info) => ({ ...info, [key]: value }));
  };

  const save = () => {
    Api.contractsUpdate(uuid, type, info).then((result) => {
      if (result.success) onSave();
    });
  };

  const title =
    type === "rent" ? "Contrato de locação" : "Contrato de monitoramento";
  return (
    <div className="border-b">
      <div
        className={classNames(
          "text-sm flex gap-3 items-center py-2 px-4 border-b",
          getTitleColor(initial)
        )}
      >
        <div className="font-bold flex-1">
          {title}
        </div>
        {!initial.sent && (
          <Link
            to={`/contratos/${type === "rent" ? "locacao" : "monitoramento"}/${uuid}`}
            target="_blank"
            className="underline text-xs font-semibold text-gray-700 hover:text-gray-500"
          >
            Abrir
          </Link>
        )}
      </div>

      <div className="px-4 pt-6 pb-8 flex flex-col gap-3">
        <div className="flex gap-2 border rounded text-sm">
          <div className="px-2 py-1">Envio por:</div>

          <select
            className="p-1 text-sm flex-1"
            value={info.type}
            onChange={(e) => set("type")(e.target.value)}
          >
            <option value="clicksign">Clicksign</option>
            <option value="other">Outro meio</option>
          </select>
        </div>

        <label className="flex flex-col">
          <span className="text-xs font-bold">
            {info.type === "clicksign" ? "Link" : "Observação"}
          </span>

          <input
            className="border rounded p-1 text-sm"
            value={info.info}
            onChange={(e) => set("info")(e.target.value)}
          />
        </label>

        <div className="flex gap-2 mt-2">
          <button
            className={classNames(
              "border rounded py-1 px-2 text-sm font-semibold",
              {
                "border-transparent text-gray-500": !info.info,
                "bg-green-100 border-green-100 text-green-800": info.sent,
              }
            )}
            disabled={!info.info || info.signed}
            onClick={() => set("sent")(!info.sent)}
          >
            <FontAwesomeIcon icon="envelope" /> Enviado
          </button>

          <button
            className={classNames(
              "border rounded py-1 px-2 text-sm font-semibold",
              {
                "border-transparent text-gray-500": !info.sent,
                "bg-green-100 border-green-100 text-green-800": info.signed,
              }
            )}
            disabled={!info.sent}
            onClick={() => set("signed")(!info.signed)}
          >
            <FontAwesomeIcon icon="check" /> Assinado
          </button>

          <div className="flex-1" />

          <button
            className={classNames("rounded py-1 px-2 text-sm font-semibold", {
              "bg-sky-600 text-white hover:bg-sky-500": isDirty,
              "bg-gray-100 text-gray-500": !isDirty,
            })}
            disabled={!isDirty}
            onClick={save}
          >
            Salvar
          </button>
        </div>
      </div>
    </div>
  );
};

export default ContractForm;

const getTitleColor = (initial: ContractInfo) => {
  if (initial.signed) return "bg-green-100";

  if (initial.sent) return "bg-yellow-100";

  return "bg-red-100";
};
